import { render } from "./juveniles-agreement.vue?vue&type=template&id=f6384c3e"
import script from "./juveniles-agreement.vue?vue&type=script&lang=js"
export * from "./juveniles-agreement.vue?vue&type=script&lang=js"

import "./juveniles-agreement.vue?vue&type=style&index=0&id=f6384c3e&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__